let sliders = document.querySelectorAll(".slider");

if (sliders.length > 0) {
  sliders.forEach((slider) => {
    // States
    let isBeginning = true;
    let isEnd = false;
    const loop = slider.hasAttribute("loop");
    const autoplay = slider.hasAttribute("autoplay");

    // Elements
    const prevButton = slider.querySelector(".slider-prev");
    const nextButton = slider.querySelector(".slider-next");

    // Options
    const slidesPerViewDesktop = slider.dataset.slidesPerViewDesktop;
    const slidesPerViewTablet = slider.dataset.slidesPerViewTablet;
    const slidesPerViewMobile = slider.dataset.slidesPerViewMobile;
    const spaceBetween = slider.dataset.spaceBetween;
    const autoplayDelay = slider.dataset.autoplayDelay;

    const config = {
      spaceBetween: spaceBetween,
      loop: loop,
      ...(autoplay && {
        autoplay: {
          delay: autoplayDelay * 1000,
          disableOnInteraction: false,
        },
      }),
      breakpoints: {
        0: {
          slidesPerView: slidesPerViewMobile,
        },
        768: {
          slidesPerView: slidesPerViewTablet,
        },
        1280: {
          slidesPerView: slidesPerViewDesktop,
        },
      },
    };

    // Swiper Instance
    const swiper = new Swiper(slider, {
      ...config,
    });

    function updateDisabledNavigation() {
      isBeginning = swiper.isBeginning;
      isEnd = swiper.isEnd;

      prevButton.disabled = isBeginning;
      nextButton.disabled = isEnd;
    }

    if (!loop) updateDisabledNavigation();

    swiper.on("slideChange", () => {
      if (!loop) updateDisabledNavigation();
    });

    // Navigation
    const prev = () => {
      swiper.slidePrev();
    };
    const next = () => {
      swiper.slideNext();
    };

    prevButton.addEventListener("click", prev);
    nextButton.addEventListener("click", next);
  });
}
